export default "__VITE_ASSET__JqS3KfR2__"